import { Box } from '@mui/material';

type ColorCircleProps = {
  color: string;
  isSelected: boolean;
  onClick: () => void;
  isFocused?: boolean;
  tabIndex?: number;
  id?: string;
  'aria-label'?: string;
};

const ColorCircle = ({
  color,
  isSelected,
  onClick,
  isFocused = false,
  tabIndex = -1,
  id,
  'aria-label': ariaLabel,
}: ColorCircleProps) => {
  const width = 2;
  const widthInEm = width + 'em';

  // Get color name for accessibility
  const colorName = ariaLabel || color;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box
        role="radio"
        aria-checked={isSelected}
        id={id}
        tabIndex={tabIndex}
        aria-label={colorName}
        onClick={onClick}
        sx={{
          width: widthInEm,
          height: widthInEm,
          borderRadius: '50%',
          backgroundColor: color,
          margin: 1,
          border: isFocused ? '2px solid #000' : '1px solid gray',
          cursor: 'pointer',
          outline: 'none',
          boxShadow: isFocused ? '0 0 0 3px rgba(25, 118, 210, 0.4)' : 'none',
          transition: 'box-shadow 0.3s, border 0.3s',
        }}
      ></Box>
      <Box
        sx={{
          width: widthInEm,
          height: width / 8 + 'em',
          borderRadius: width / 2 + 'em',
          backgroundColor: color,
          opacity: isSelected ? 1 : 0,
        }}
      ></Box>
    </Box>
  );
};

export default ColorCircle;
